import {
    FaBell,
    FaPaperPlane,
    FaClock,
    FaFileAlt,
    FaExclamationTriangle,
} from "react-icons/fa";

import "./../../styles/NotificationStats.css";

const NotificationStats = ({ stats }) => {

    const cards = [
        {
            title: "Total",
            value: stats.total || 0,
            icon: <FaBell />,
        },
        {
            title: "Draft",
            value: stats.draft || 0,
            icon: <FaFileAlt />,
        },
        {
            title: "Scheduled",
            value: stats.scheduled || 0,
            icon: <FaClock />,
        },
        {
            title: "Sent",
            value: stats.sent || 0,
            icon: <FaPaperPlane />,
        },
        {
            title: "Failed",
            value: stats.failed || 0,
            icon: <FaExclamationTriangle />,
        },
    ];

    return (
        <div className="notification-stats">

            {cards.map((card) => (
                <div
                    key={card.title}
                    className="notification-card"
                >
                    <div className="notification-icon">
                        {card.icon}
                    </div>

                    <div>
                        <h3>{card.value}</h3>
                        <span>{card.title}</span>
                    </div>
                </div>
            ))}

        </div>
    );
};

export default NotificationStats;